/* By Sophi v2 PDP — extracted JS. Reads Liquid context from data attributes on the root element. */
(function(){
  var root = document.querySelector('[data-bs-v2-pdp-root]');
  if (!root) return;

  /* ---------- Gallery scroll-snap: thumb click → scroll main; main scroll → activate thumb + counter ---------- */
  var bsGalleryGoTo = null; /* set by the gallery block below; used by the variant block to show a variant's image */
  (function(){
    var main = root.querySelector('[data-bs-v2-gallery-main]');
    var thumbs = root.querySelectorAll('[data-bs-v2-thumb-index]');
    var counter = root.querySelector('[data-bs-v2-gallery-count]');
    if (!main) return;
    var slides = main.querySelectorAll('[data-bs-v2-slide-index]');
    var total = slides.length;

    function setActive(idx){
      thumbs.forEach(function(t){ t.classList.toggle('is-active', parseInt(t.dataset.bsV2ThumbIndex,10) === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + total;
    }

    function goTo(idx, instant){
      var slide = main.querySelector('[data-bs-v2-slide-index="' + idx + '"]');
      if (slide) {
        var beh = instant ? 'auto' : 'smooth';
        var pane = main.closest('.gallery');
        if (main.scrollWidth > main.clientWidth + 1) {
          main.scrollTo({ left: slide.offsetLeft, behavior: beh }); /* mobile: horizontal scroll-snap */
        } else if (pane && pane.scrollHeight > pane.clientHeight + 1) {
          pane.scrollTo({ top: pane.scrollTop + slide.getBoundingClientRect().top - pane.getBoundingClientRect().top, behavior: beh }); /* desktop: stacked slides in the scrolling .gallery pane */
        }
      }
      setActive(idx);
    }
    bsGalleryGoTo = goTo;

    thumbs.forEach(function(thumb){
      thumb.addEventListener('click', function(){
        goTo(parseInt(thumb.dataset.bsV2ThumbIndex, 10) || 0);
      });
    });

    var scrollTimer;
    main.addEventListener('scroll', function(){
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function(){
        var w = main.clientWidth || 1;
        var idx = Math.round(main.scrollLeft / w);
        if (idx < 0) idx = 0;
        if (idx >= total) idx = total - 1;
        setActive(idx);
      }, 80);
    });
  })();

  /* ---------- Variant label sync + variant change dispatcher (CRITICAL for ATC) ---------- */
  /* Impulse's theme.Product class fails to initialize (theme.js TypeError) so it never
     dispatches variantChange.product. We dispatch it ourselves from the radio change event,
     using the product.variants JSON to find the matching variant. Also synchronously updates
     the form's <select name="id"> and hidden <input name="id"> so ATC submits the correct variant. */
  (function(){
    var inputs = root.querySelectorAll('input[data-variant-input]');
    var variants = [];
    var jsonEl = root.querySelector('[data-variant-json]');
    if (jsonEl) {
      try { variants = JSON.parse(jsonEl.value || jsonEl.textContent || '[]'); }
      catch(e) { console.warn('[bs-v2 variant] JSON parse failed', e); }
    }

    function syncLabels(){
      inputs.forEach(function(inp){
        var lbl = root.querySelector('label[for="' + inp.id + '"]');
        if (!lbl) return;
        lbl.classList.toggle('is-selected', inp.checked);
      });
    }

    function findVariant(){
      if (!variants.length) return null;
      var selected = [];
      inputs.forEach(function(inp){ if (inp.checked) selected.push(inp.value); });
      if (!selected.length) return null;
      return variants.find(function(v){
        return v.options && v.options.length === selected.length &&
               v.options.every(function(opt, i){ return opt === selected[i]; });
      });
    }

    /* Slide index for a variant's own image (variant JSON featured_image.position, 1-based); -1 when it has none or no slide matches */
    function variantSlideIdx(v){
      var f = v && v.featured_image;
      if (!f || !bsGalleryGoTo) return -1;
      var main = root.querySelector('[data-bs-v2-gallery-main]');
      if (!main) return -1;
      var idx = (parseInt(f.position, 10) || 0) - 1;
      if (idx >= 0 && main.querySelector('[data-bs-v2-slide-index="' + idx + '"]')) return idx;
      var base = String(f.src || '').split('?')[0].split('/').pop().replace(/\.[^.]+$/, '');
      if (!base) return -1;
      var found = -1;
      main.querySelectorAll('[data-bs-v2-slide-index]').forEach(function(sl){
        var im = sl.querySelector('img');
        if (found < 0 && im && String(im.currentSrc || im.getAttribute('src') || '').indexOf(base) > -1) found = parseInt(sl.getAttribute('data-bs-v2-slide-index'), 10);
      });
      return found;
    }

    var lastImgId = null;
    function onChange(){
      syncLabels();
      var v = findVariant();
      if (!v) return;
      /* Show the picked variant's own image in the gallery; no variant image, or same image as the previous pick → gallery stays put */
      var fid = v.featured_image ? v.featured_image.id : null;
      var gi = fid !== lastImgId ? variantSlideIdx(v) : -1;
      lastImgId = fid;
      if (gi > -1) bsGalleryGoTo(gi);
      /* Synchronously update the form's variant id BEFORE any ATC click can fire — critical */
      root.querySelectorAll('input[name="id"]').forEach(function(inp){ inp.value = v.id; });
      root.querySelectorAll('select[name="id"]').forEach(function(sel){ sel.value = v.id; });
      /* Update Buy Now button's variant id too (wallet-flow uses this) */
      var buynow = root.querySelector('[data-bs-v2-buynow]');
      if (buynow) buynow.setAttribute('data-variant-id', v.id);
      /* Dispatch event for other listeners (price/labels/availability handlers) */
      document.dispatchEvent(new CustomEvent('variantChange.product', { detail: { variant: v } }));
    }

    inputs.forEach(function(inp){ inp.addEventListener('change', onChange); });
    syncLabels();
    var iv = findVariant();
    lastImgId = iv && iv.featured_image ? iv.featured_image.id : null;

    /* Landing on ?variant=<id>: jump (no smooth scroll) to that variant's image once */
    try {
      var vid = new URL(window.location.href).searchParams.get('variant');
      var lv = vid && variants.find(function(x){ return String(x.id) === vid; });
      var li = lv ? variantSlideIdx(lv) : -1;
      if (li > -1) bsGalleryGoTo(li, true);
    } catch(e) {}
  })();

  /* ---------- FAQ accordion ---------- */
  root.querySelectorAll('.faq-trigger').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.closest('.faq-item').classList.toggle('is-open');
    });
  });

  /* ---------- Quantity selector (mockup-styled) ---------- */
  (function(){
    var input = root.querySelector('[data-bs-v2-qty-input]');
    var minus = root.querySelector('[data-bs-v2-qty-minus]');
    var plus  = root.querySelector('[data-bs-v2-qty-plus]');
    if (!input || !minus || !plus) return;
    function clamp(v){ var n = parseInt(v, 10); if (isNaN(n) || n < 1) return 1; return n; }
    minus.addEventListener('click', function(){
      input.value = Math.max(1, clamp(input.value) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    plus.addEventListener('click', function(){
      input.value = clamp(input.value) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();

  /* ---------- Write Review → click Judge.me's hidden write button (revamp or classic widget) ---------- */
  var writeBtn = root.querySelector('[data-bs-v2-write-review]');
  if (writeBtn) {
    writeBtn.addEventListener('click', function(){
      /* Try every known Judge.me write-review trigger selector across widget variants */
      var sel = [
        '.jm-button.jm-button--primary.jm-action-buttons__button',
        '.jm-action-buttons__button',
        '.jm-button--primary',
        '.jdgm-write-rev-link',
        '.jdgm-rev-widg__main-write-rev-btn',
        '[class*="write-review"]'
      ];
      for (var i = 0; i < sel.length; i++) {
        var btn = document.querySelector(sel[i]);
        if (btn) { btn.click(); return; }
      }
      /* Fall back: scroll to the embedded widget */
      var wid = document.querySelector('[data-bs-v2-jdgm-slot]');
      if (wid) wid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  var readAllBtn = root.querySelector('[data-bs-v2-read-all]');
  if (readAllBtn) {
    readAllBtn.addEventListener('click', function(e){
      var wid = document.querySelector('[data-bs-v2-jdgm-slot]');
      if (wid) { e.preventDefault(); wid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }

  /* ---------- IP geo → personalize "Ships in 24h" pill with visitor city ---------- */
  (function(){
    var tag = root.querySelector('[data-bs-v2-ship-city]');
    if (!tag) return;
    try {
      var cached = localStorage.getItem('bs_visitor_city');
      if (cached) { tag.textContent = 'Ships in 24h to ' + cached; return; }
    } catch (e) {}
    fetch('https://ipapi.co/json/')
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(d){
        if (d && d.city && d.city.length < 30) {
          try { localStorage.setItem('bs_visitor_city', d.city); } catch (e) {}
          tag.textContent = 'Ships in 24h to ' + d.city;
        }
      })
      .catch(function(){});
  })();

  /* ---------- Shipping cutoff (3pm Sydney, refresh every 60s) ---------- */
  function renderCutoff(){
    var el = root.querySelector('[data-bs-v2-shipping-cutoff-text]');
    if (!el) return;
    try {
      var sydneyNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' }));
      var cutoff = new Date(sydneyNow);
      cutoff.setHours(15, 0, 0, 0);
      if (sydneyNow >= cutoff) {
        el.innerHTML = 'Order today &mdash; processing begins tomorrow';
        return;
      }
      var diffMs = cutoff - sydneyNow;
      var totalMin = Math.floor(diffMs / 60000);
      var h = Math.floor(totalMin / 60);
      var m = totalMin % 60;
      var t = h > 0 ? (m > 0 ? h + 'h ' + m + 'm' : h + 'h') : m + 'm';
      el.innerHTML = 'Order in the next <strong>' + t + '</strong> for next-day processing';
    } catch (e) {}
  }
  renderCutoff();
  setInterval(renderCutoff, 60000);

  /* ---------- Buy Now (wallet-aware: Apple Pay / Google Pay / generic) ---------- */
  (function(){
    var btn = root.querySelector('[data-bs-v2-buynow]');
    if (!btn) return;
    var label = btn.querySelector('[data-bs-v2-buynow-label]');
    var ua = navigator.userAgent || '';
    var isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    var isMac = /Macintosh/.test(ua);
    var isAndroid = /android/i.test(ua);
    var hasApplePay = (isIOS || isMac) && typeof window.ApplePaySession !== 'undefined' && window.ApplePaySession.canMakePayments;
    var hasGooglePay = isAndroid && typeof window.PaymentRequest !== 'undefined';

    if (hasApplePay) {
      btn.classList.add('is-applepay');
      /* viewBox expanded to 56 wide so the "y" tail of "Pay" isn't clipped */
      if (label) label.innerHTML = 'Buy now with <svg class="buynow-btn__logo" viewBox="-1 -1 56 22" xmlns="http://www.w3.org/2000/svg" aria-label="Apple Pay" role="img" preserveAspectRatio="xMidYMid meet"><path d="M9.06 4.85c-.6.7-1.55 1.26-2.5 1.18-.12-.95.34-1.97.9-2.59C8.07 2.7 9.1 2.2 9.94 2.15c.1.99-.28 1.97-.88 2.7zm.87 1.37c-1.38-.08-2.56.79-3.21.79-.66 0-1.66-.75-2.74-.73-1.41.02-2.72.82-3.43 2.09-1.47 2.55-.39 6.31 1.05 8.38.7 1.02 1.55 2.15 2.66 2.11 1.06-.04 1.46-.69 2.74-.69 1.27 0 1.64.69 2.74.67 1.14-.02 1.86-1.03 2.56-2.05.8-1.17 1.13-2.3 1.15-2.36-.03-.01-2.2-.84-2.22-3.34-.02-2.09 1.7-3.1 1.78-3.16-.97-1.44-2.49-1.6-3.02-1.63-1.36-.1-2.49.74-3.06.74zm10.99-3.95v15h2.33v-5.13h3.23c2.95 0 5.02-2.02 5.02-4.94 0-2.92-2.03-4.93-4.94-4.93h-5.64zm2.33 1.96h2.7c2.03 0 3.19 1.08 3.19 2.98 0 1.9-1.16 3-3.2 3h-2.69V4.23zm12.71 13.15c1.46 0 2.81-.74 3.43-1.91h.05v1.8h2.15v-7.45c0-2.16-1.73-3.55-4.38-3.55-2.47 0-4.29 1.41-4.36 3.35h2.1c.17-.92 1.03-1.53 2.2-1.53 1.42 0 2.21.66 2.21 1.88v.82l-2.9.17c-2.7.16-4.16 1.26-4.16 3.18 0 1.94 1.51 3.24 3.66 3.24zm.62-1.77c-1.24 0-2.02-.6-2.02-1.51 0-.94.75-1.49 2.2-1.58l2.58-.16v.84c0 1.4-1.18 2.41-2.76 2.41zm7.6 5.79c2.27 0 3.34-.87 4.27-3.5l4.09-11.47h-2.37l-2.74 8.86h-.05l-2.74-8.86h-2.43l3.95 10.93-.21.67c-.36 1.13-.94 1.57-1.97 1.57-.18 0-.54-.02-.68-.04v1.8c.13.04.71.04.89.04z" fill="#fff"/></svg>';
    } else if (hasGooglePay) {
      btn.classList.add('is-gpay');
      if (label) label.innerHTML = 'Buy now with <img class="buynow-btn__logo" src="' + (btn.getAttribute('data-bs-v2-gpay-url') || '') + '" alt="Google Pay">';
    }

    btn.addEventListener('click', function(e){
      e.preventDefault();
      if (btn.disabled) return;
      var variantId = btn.dataset.variantId;
      var qtyInput = root.querySelector('.js-qty__num, input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      btn.disabled = true;
      btn.style.opacity = '0.6';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .then(function(r){ if (!r.ok) throw new Error('add to cart failed'); window.location.href = '/checkout'; })
      .catch(function(err){ console.warn('[bs-v2 buynow]', err); btn.disabled = false; btn.style.opacity = ''; });
    });

    document.addEventListener('variantChange.product', function(e){
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      btn.dataset.variantId = v.id;
      btn.disabled = !v.available;
      btn.style.opacity = v.available ? '' : '0.5';
      if (label && !btn.classList.contains('is-applepay') && !btn.classList.contains('is-gpay')) {
        label.innerHTML = v.available ? 'Buy Now &rarr;' : 'Sold out';
      }
    });
  })();

  /* Money formatter for variant-change price updates: uses the theme's own money format when available
     (matches Liquid's | money, incl. thousands separators), else falls back to $0.00. Input is cents. */
  function bsFmtMoney(cents){
    try {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function' && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Variant change → price, installments, hidden id, labels, selected-value text ---------- */
  document.addEventListener('variantChange.product', function(e){
    if (!e.detail || !e.detail.variant) return;
    var v = e.detail.variant;

    var idIn = root.querySelector('input[data-product-select-id]');
    if (idIn) idIn.value = v.id;

    /* Main price block: price, compare-at, Save %, and Shop Pay installments, from the variant JSON.
       (Added 2026-10-20: this handler previously only updated installments, so .price-current stayed on the first variant.) */
    var priceEl = root.querySelector('[data-product-price]');
    if (priceEl && typeof v.price === 'number') priceEl.textContent = bsFmtMoney(v.price);

    var wasEl = root.querySelector('[data-compare-price]');
    var saveEl = root.querySelector('[data-save-price]');
    var onSale = typeof v.compare_at_price === 'number' && v.compare_at_price > v.price;
    if (wasEl) {
      if (onSale) {
        wasEl.textContent = bsFmtMoney(v.compare_at_price);
        wasEl.classList.remove('hide');
        wasEl.style.display = '';
      } else {
        wasEl.textContent = '';
        wasEl.classList.add('hide');
        wasEl.style.display = 'none';
      }
    }
    if (saveEl) {
      if (onSale) {
        saveEl.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        saveEl.classList.remove('hide');
        saveEl.style.display = '';
      } else {
        saveEl.textContent = '';
        saveEl.classList.add('hide');
        saveEl.style.display = 'none';
      }
    }

    var inst = root.querySelector('[data-bs-v2-installment]');
    if (inst && typeof v.price === 'number') {
      inst.textContent = bsFmtMoney(Math.floor(v.price / 4));
    }

    root.querySelectorAll('input[data-variant-input]').forEach(function(inp){
      var lbl = root.querySelector('label[for="' + inp.id + '"]');
      if (lbl) lbl.classList.toggle('is-selected', inp.checked);
    });

    /* Update the "Size: 7" / "Color: Gold" selected-value text spans */
    if (Array.isArray(v.options) && v.options.length) {
      root.querySelectorAll('[data-bs-v2-option-name]').forEach(function(){});
      var spans = root.querySelectorAll('[id^="bs-v2-selected-"], .variant-selected');
      v.options.forEach(function(val, i){
        var blocks = root.querySelectorAll('.variant-wrapper');
        if (blocks[i]) {
          var sel = blocks[i].querySelector('.variant-selected');
          if (sel) sel.textContent = val;
        }
      });
    }

    /* ATC button availability (sold-out state) */
    var atcBtn = root.querySelector('[data-add-to-cart]');
    var atcText = root.querySelector('[data-add-to-cart-text]');
    if (atcBtn && atcText) {
      if (v.available) {
        atcBtn.removeAttribute('disabled');
        atcText.textContent = atcText.getAttribute('data-default-text') || 'Add to cart';
      } else {
        atcBtn.setAttribute('disabled', 'disabled');
        atcText.textContent = 'Sold out';
      }
    }

    /* Sticky mobile bar ATC also tracks availability */
    var stickyBtn = document.querySelector('[data-bs-v2-sticky-atc]');
    if (stickyBtn) {
      if (v.available) {
        stickyBtn.removeAttribute('disabled');
        stickyBtn.textContent = 'Add to cart';
      } else {
        stickyBtn.setAttribute('disabled', 'disabled');
        stickyBtn.textContent = 'Sold out';
      }
    }

    /* Push variant id into the URL so reloads/sharing preserves selection */
    if (window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch(e) {}
    }
  });

  /* ---------- Sticky mobile ATC bar (IntersectionObserver on main ATC) ---------- */
  var sticky = document.querySelector('[data-bs-v2-sticky]');
  var mainAtc = root.querySelector('button[name="add"]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    document.body.classList.add('v2-has-sticky-atc');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ sticky.classList.toggle('is-visible', !e.isIntersecting); });
    }, { rootMargin: '0px 0px -80px 0px' });
    io.observe(mainAtc);

    /* Hide sticky ATC whenever the cart drawer is open — otherwise the bar overlaps with the
       drawer footer's CHECK OUT button, creating a worse UX. */
    function hideStickyForDrawer(){ sticky.classList.add('is-drawer-hidden'); }
    function restoreStickyAfterDrawer(){ sticky.classList.remove('is-drawer-hidden'); }
    /* Impulse fires named drawer events */
    document.addEventListener('drawerOpen.CartDrawer', hideStickyForDrawer);
    document.addEventListener('drawerClose.CartDrawer', restoreStickyAfterDrawer);
    /* Also catch generic drawer events + clicks on open/close triggers as fallback */
    document.addEventListener('click', function(e){
      if (e.target && e.target.closest && e.target.closest('.js-drawer-open-cart, [data-drawer-open="CartDrawer"], [aria-controls="CartDrawer"]')) {
        hideStickyForDrawer();
      }
      if (e.target && e.target.closest && e.target.closest('.js-drawer-close, .cdd__close, [data-drawer-close]')) {
        restoreStickyAfterDrawer();
      }
    }, true);
    /* Watch for drawer element class changes as a final safety net (covers any open/close path) */
    var drawerEl = document.getElementById('CartDrawer');
    if (drawerEl && 'MutationObserver' in window) {
      new MutationObserver(function(){
        if (drawerEl.classList.contains('is-open') || drawerEl.classList.contains('drawer--is-open') || drawerEl.classList.contains('js-drawer-open')) {
          hideStickyForDrawer();
        } else {
          restoreStickyAfterDrawer();
        }
      }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }
    var stickyAtc = sticky.querySelector('[data-bs-v2-sticky-atc]');
    if (stickyAtc) {
      stickyAtc.addEventListener('click', function(){
        mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function(){ mainAtc.click(); }, 400);
      });
    }
    document.addEventListener('variantChange.product', function(e){
      if (!e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      var p = sticky.querySelector('[data-bs-v2-sticky-price]');
      if (p && typeof v.price === 'number') p.textContent = bsFmtMoney(v.price);
      var pw = sticky.querySelector('[data-bs-v2-sticky-price-was]');
      if (pw) {
        if (typeof v.compare_at_price === 'number' && v.compare_at_price > v.price) {
          pw.textContent = bsFmtMoney(v.compare_at_price);
          pw.style.display = '';
        } else {
          pw.style.display = 'none';
        }
      }
      if (stickyAtc) {
        stickyAtc.disabled = !v.available;
        stickyAtc.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
    });
  }

  /* ---------- Desktop split-pane scroll: forward wheel events at column boundary to page ---------- */
  /* Browser default trap: when an overflow-y:auto container hits its end, the first wheel event
     is "absorbed" by the boundary and a second wheel event is needed for it to bubble to the page.
     That double-attempt feels broken. Below we intercept wheel events at the column boundary and
     forward them to window.scrollBy immediately on the first attempt — seamless passthrough. */
  (function(){
    var grid = root.querySelector('.v2-pdp-grid');
    if (!grid) return;
    var panes = grid.querySelectorAll('.gallery, .v2-info-pane');
    if (!panes.length) return;

    function onWheel(e){
      /* Only active at desktop width — mobile uses single-column flow with no inner scroll */
      if (window.innerWidth < 768) return;
      var pane = e.currentTarget;
      var dy = e.deltaY;
      if (!dy) return;
      var atTop = pane.scrollTop <= 0;
      var atBottom = Math.ceil(pane.scrollTop + pane.clientHeight) >= pane.scrollHeight;
      /* If scrolling down and at bottom OR scrolling up and at top, forward to the page */
      if ((dy > 0 && atBottom) || (dy < 0 && atTop)) {
        e.preventDefault();
        window.scrollBy({ top: dy, left: 0, behavior: 'auto' });
      }
    }
    panes.forEach(function(p){ p.addEventListener('wheel', onWheel, { passive: false }); });

    /* Touch fallback for trackpads that don't fire wheel cleanly — also handle touchmove
       so swipe gestures past the boundary forward to the page */
    var touchStartY = null;
    function onTouchStart(e){ if (e.touches && e.touches[0]) touchStartY = e.touches[0].clientY; }
    function onTouchMove(e){
      if (window.innerWidth < 768 || touchStartY === null) return;
      var pane = e.currentTarget;
      var currentY = e.touches[0].clientY;
      var dy = touchStartY - currentY;  /* positive = swiping up = scrolling down */
      var atTop = pane.scrollTop <= 0;
      var atBottom = Math.ceil(pane.scrollTop + pane.clientHeight) >= pane.scrollHeight;
      if ((dy > 0 && atBottom) || (dy < 0 && atTop)) {
        window.scrollBy({ top: dy, left: 0, behavior: 'auto' });
        touchStartY = currentY;
      }
    }
    panes.forEach(function(p){
      p.addEventListener('touchstart', onTouchStart, { passive: true });
      p.addEventListener('touchmove', onTouchMove, { passive: true });
    });
  })();

  /* ---------- Move Judge.me's rendered widget into our v2 reviews slot ---------- */
  /* Judge.me's apps section renders at the bottom of the page. We wait for it to populate
     with review markup, then move it into our slot. Selectors are permissive because Judge.me
     widget class names vary by version (jdgm-rev-widg vs jdgm-all-reviews vs jdgm-carousel etc). */
  (function(){
    var slot = root.querySelector('[data-bs-v2-jdgm-slot]');
    if (!slot) return;

    var moved = false;
    var attempts = 0;
    var maxAttempts = 40; /* 20s */

    function findJdgmSection(){
      /* 1) Try the named Shopify section first */
      var named = document.getElementById('shopify-section-17784519306b210503');
      if (named && named.querySelector('[class*="jdgm-"]')) return named;
      /* 2) Look for any apps-type Shopify section containing jdgm- elements that have review content */
      var sections = document.querySelectorAll('.shopify-section');
      for (var i = 0; i < sections.length; i++) {
        var s = sections[i];
        if (s.contains(slot)) continue; /* skip our own section */
        var jdgmEls = s.querySelectorAll('[class*="jdgm-"]');
        if (jdgmEls.length === 0) continue;
        /* Confirm it has populated review content (not just an empty placeholder) */
        var hasReviewContent = s.querySelector('[class*="jdgm-rev"], [class*="jdgm-review"], [class*="jdgm-paginate"]');
        var hasText = (s.innerText || '').length > 100;
        if (hasReviewContent && hasText) return s;
      }
      return null;
    }

    function tryMove(){
      if (moved) return;
      attempts++;
      var section = findJdgmSection();
      if (section) {
        /* Move the section's CONTENTS (not the section wrapper itself, which Shopify expects to remain) */
        var wrapper = document.createElement('div');
        wrapper.className = 'bs-v2-jdgm-moved';
        while (section.firstChild) wrapper.appendChild(section.firstChild);
        slot.appendChild(wrapper);
        section.style.display = 'none';
        section.setAttribute('aria-hidden', 'true');
        moved = true;
        console.log('[bs-v2 reviews] moved Judge.me widget into v2 slot — section was', section.id || section.className);
        return;
      }
      if (attempts < maxAttempts) setTimeout(tryMove, 500);
      else {
        console.warn('[bs-v2 reviews] Judge.me widget never populated after ' + (maxAttempts * 0.5) + 's. Diagnostic:');
        console.warn('[bs-v2 reviews] jdgm-prefixed elements on page:',
          [].slice.call(document.querySelectorAll('[class*="jdgm-"]')).slice(0, 10).map(function(el){ return el.tagName + '.' + (el.className||'').toString().split(' ').filter(function(c){return c.indexOf('jdgm-')===0;}).join('.'); }));
      }
    }

    if (document.readyState === 'complete') setTimeout(tryMove, 1500);
    else window.addEventListener('load', function(){ setTimeout(tryMove, 1500); });
  })();

  /* ---------- AJAX ATC → open v2 cart drawer (instead of navigating to /cart) ---------- */
  (function(){
    var form = root.querySelector('.product-single__form, form[action$="/cart/add"]');
    if (!form) return;
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addText = form.querySelector('[data-add-to-cart-text]');
    var defaultText = (addText && addText.getAttribute('data-default-text')) || (addText && addText.textContent.trim()) || 'Add to cart';

    function openCartDrawer(){
      /* Try every known mechanism — first one that works wins */
      if (window.theme && theme.cart && typeof theme.cart.openCart === 'function') { theme.cart.openCart(); return; }
      if (window.theme && theme.cartDrawer && typeof theme.cartDrawer.open === 'function') { theme.cartDrawer.open(); return; }
      if (window.theme && theme.Drawers) {
        try { (new theme.Drawers('CartDrawer', 'cart')).open(); return; } catch (e) {}
      }
      /* Fire the events the v2 cart-drawer-d.js listens for */
      document.dispatchEvent(new CustomEvent('drawerOpen.CartDrawer', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('drawerOpen', { bubbles: true }));
      /* Click the header cart trigger as a last-resort fallback */
      var trigger = document.querySelector('.js-drawer-open-cart, [data-drawer-open="CartDrawer"], [data-drawer="CartDrawer"]');
      if (trigger) trigger.click();
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if (addBtn && addBtn.hasAttribute('disabled')) return;
      if (addBtn) addBtn.setAttribute('disabled','disabled');
      if (addText) addText.textContent = 'Adding…';

      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function(r){
          if (!r.ok) return r.json().then(function(err){ throw err; });
          return r.json();
        })
        .then(function(item){
          if (addText) addText.textContent = 'Added ✓';
          /* Rebuild the Impulse cart drawer markup */
          if (window.theme && theme.cart && typeof theme.cart.buildCart === 'function') {
            theme.cart.buildCart();
          }
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: item } }));
          openCartDrawer();
          setTimeout(function(){
            if (addText) addText.textContent = defaultText;
            if (addBtn) addBtn.removeAttribute('disabled');
          }, 1400);
        })
        .catch(function(err){
          console.warn('[bs-v2 ATC] failed', err);
          if (addText) addText.textContent = (err && err.description) || 'Try again';
          if (addBtn) addBtn.removeAttribute('disabled');
          setTimeout(function(){ if (addText) addText.textContent = defaultText; }, 2200);
        });
    });
  })();

  /* ---------- Wishlist (localStorage bs_wishlist; sync hearts + header badge) ---------- */
  (function(){
    var KEY = 'bs_wishlist';
    function read(){ try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
    function write(arr){ try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {} }
    function sync(){
      var list = read();
      root.querySelectorAll('.bs-v2-wishlist-trigger').forEach(function(btn){
        var handle = btn.dataset.productHandle;
        btn.classList.toggle('is-saved', list.indexOf(handle) > -1);
      });
      var countEl = document.getElementById('wishlist-count');
      if (countEl) {
        countEl.textContent = list.length;
        countEl.classList.toggle('is-visible', list.length > 0);
      }
    }
    function syncGlobal(){
      /* Update header badge + collection-card hearts via bs-v2.js global sync */
      if (window.BSv2 && window.BSv2.wishlist && typeof window.BSv2.wishlist.sync === 'function') {
        window.BSv2.wishlist.sync();
      }
    }
    root.querySelectorAll('.bs-v2-wishlist-trigger').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var handle = btn.dataset.productHandle;
        var list = read();
        var i = list.indexOf(handle);
        if (i === -1) list.push(handle);
        else list.splice(i, 1);
        write(list);
        sync();
        syncGlobal();
      });
    });
    sync();
    syncGlobal();
    window.addEventListener('storage', function(e){ if (e.key === KEY) { sync(); syncGlobal(); } });
  })();
})();